export default "images/activity.png";